wbApp.controller('FranchisesEmployeesLicenseDetailCtrl', ['$scope', 'tenantInfo', 'subjectsSvc',
function ($scope, tenantInfo, subjectsSvc) {
    $scope.model = angular.copy($scope.modelOrig);
    $scope.franchiseCentralTenantID = tenantInfo.tenantID;
     
    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {            
            angular.extend($scope.modelOrig, data);
            delete $scope.modelOrig.isNew;
            $scope.licenses.push($scope.modelOrig);
        } else {
            angular.extend($scope.modelOrig, data);
        }

        subjectsSvc.getFranchiseCentralSubject($scope.franchiseCentralTenantID, $scope.modelOrig.franchiseSubjectID)
        .then(function (subject) {
            $scope.modelOrig.franchiseSubjectName = subject.name;
            $scope.$hide();
        }, function (error) {
            $scope.detailError = error;
            $scope.isSaving = false;
        });
        
    }


}]);